import React from "react";
import { Button, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { monthsArr, yearsArr } from "utils/config";

export const DatePick = ({ month, setMonth, year, setYear, dispatchActionOnClick, isMobile }) => {
  const monthsItems = monthsArr.map((m, index) => ({
    key: index,
    label: m,
    onClick: () => setMonth(m),
  }));

  const yearsItems = yearsArr.map((y, index) => ({
    key: index,
    label: y,
    onClick: () => setYear(y),
  }));

  return (
    <div style={{ margin: "0px 0px" }}>
      <Dropdown menu={{ items: monthsItems }} trigger={["click"]}>
        <a style={{ margin: "0 10px", fontSize: "1.2em" }} href="/#" onClick={(e) => e.preventDefault()}>
          {month} <DownOutlined />
        </a>
      </Dropdown>
      <Dropdown menu={{ items: yearsItems }} trigger={["click"]}>
        <a style={{ margin: "0 10px", fontSize: "1.2em" }} href="/#" onClick={(e) => e.preventDefault()}>
          {year} <DownOutlined />
        </a>
      </Dropdown>

      <Button
        style={{ margin: "10px 0" }}
        type="primary"
        onClick={dispatchActionOnClick}
        size={isMobile ? "small" : "large"}
      >
        Search
      </Button>
    </div>
  );
};

export default DatePick;
